module.exports = __webpack_public_path__ + "img/help_2.f9a7fa7b.png";